import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FastAPIService, News, Solver, SentimentResults } from 'src/app/service/fast-api.service';

@Component({
  selector: 'app-list-results',
  templateUrl: './list-results.component.html',
  styleUrls: ['./list-results.component.scss']
})
export class ListResultsComponent {

  image_path = "assets/search-component-images/";

  list_icon_active = `${this.image_path}list_icon_active.svg`;
  list_icon_deactive = `${this.image_path}list_icon_deactive.svg`;
  box_icon_active = `${this.image_path}box_icon_active.svg`;
  box_icon_deactive = `${this.image_path}box_icon_deactive.svg`;
  list_icon = this.list_icon_deactive;
  box_icon = `${this.image_path}box-icon.svg`;
  result_corner_icon = `${this.image_path}result-corner-icon.svg`;
  view_icon = `${this.image_path}view_icon.svg`;
  mapPin_icon = `${this.image_path}MapPin.svg`;

  filter = new Solver().solve().filter;

  constructor(public fastService: FastAPIService) { }

  @Input() results: News[] = [];
  @Input() loading = true;
  @Input() descriptionLines = 1;
  @Input() showMapButton = false;
  @Input() imageHeight = "150px";
  @Input() imageRatio = 4 / 3;
  @Input() nameDateConnect = false;
  @Input() skeleton = false;
  @Input() showMoreButton = true;
  @Input() reachTheEnd = false;

  @Output() onRequestMoreSearchResults = new EventEmitter<any>();
  @Output() onResultClick = new EventEmitter<News>();
  @Output() onMapButtonClick = new EventEmitter<News>();

  checkScrollEnd(event: any) {
    if (this.loading || this.results.length >= 30 || this.reachTheEnd) return;
    const { clientHeight, scrollHeight, scrollTop } = event.srcElement;
    if (clientHeight + scrollTop >= scrollHeight - 300) {
      this.onRequestMoreSearchResults.emit();
    }
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.fastService.getDefaultImage();
  }

  getSentimentTooltip(sentiment: SentimentResults) {
    if (sentiment) {
      return `ข่าวมีโอกาสเป็น เชิงบวก ${(sentiment.pos * 100).toFixed(2)}%, เชิงลบ ${(sentiment.neg * 100).toFixed(2)}% และเป็นกลาง ${(sentiment.neu * 100).toFixed(2)}%`;
    }
    return ''
  }
}
